import log from 'salvo-lite/log'
import 'dom-slider'

class Slide {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.getAttribute('data-slide'))
        this._elemToChange = this._data.elem
        this._action = this._data.action || null
        this._delay = this._data.delay || null
        this._maxWidth = this._data.maxWidth || 9999999
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            if (window.innerWidth <= this._maxWidth) {
                if (Array.isArray(this._elemToChange)) {
                    for (var i = 0; i < this._elemToChange.length; i++) {
                        this.function(this._elemToChange[i], this._action[i], i)
                    }
                } else {
                    this.function(this._elemToChange, this._action)
                }
            }
            if (this._data.closeSiblings) {
                this.closeSiblings(this._elemToChange)
            }
        })
    }

    function (element, action, count) {
        switch (element) {
        case 'parent':
            element = this._elem.parentNode
            break
        case 'child':
            element = this._elem.childElementSibling
            break
        case 'next':
            element = this._elem.nextElementSibling
            break
        case 'prev':
            element = this._elem.previousElementSibling
            break
        default:
            element = document.querySelector(element)
        }

        if (this._delay && count > 0) {
            setTimeout(function () {
                switch (action) {
                case 'show':
                    element.slideDown()
                    break
                case 'hide':
                    element.slideUp()
                    break
                default:
                    element.slideToggle()
                }
            }, this._delay)
        } else {
            switch (action) {
            case 'show':
                element.slideDown()
                break
            case 'hide':
                element.slideUp()
                break
            default:
                element.slideToggle()
            }
        }
    }

    closeSiblings (elem) {
        const siblings = document.querySelectorAll(this._data.closeSiblings)
        siblings.forEach(sibling => {
            if (sibling !== document.querySelector(elem)) {
                if (this._data.closeSiblingsElement) {
                    sibling.querySelector(this._data.closeSiblingsElement).slideUp()
                } else {
                    sibling.slideUp()
                }
            }
        })
    }
}

export default Slide



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slide.js